import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import { useLang } from "@/i18n/LanguageContext";

const CONTENT = {
  impressum: {
    sections: [
      { h: "Betreiberin dieser Website", p: "MYSYMP AG\nStudenstrasse 14B\nCH-6207 Nottwil\nSchweiz\n\nMira Mirror (mira-mirror.ai) ist ein Produkt der MYSYMP AG." },
      { h: "Kontakt", p: "E-Mail: info@mysymp.ch\nTelefon: +41 79 471 06 25\nWeb: mira-mirror.ai · mysymp.ch" },
      { h: "Vertretungsberechtigte Personen", p: "Isidoro Celentano — CEO / Founder" },
      { h: "Handelsregistereintrag", p: "Eingetragener Firmenname: MYSYMP AG\nNummer: CHE-192.170.455\nHandelsregisteramt: Nottwil" },
      { h: "Mehrwertsteuernummer", p: "CHE-192.170.455 MWST" },
      { h: "Haftungsausschluss", p: "Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschliesslich deren Betreiber verantwortlich." },
    ],
  },
  datenschutz: {
    sections: [
      { h: "Einleitung", p: "Diese Datenschutzerklärung informiert Sie über die Bearbeitung Ihrer Personendaten durch die MYSYMP AG gemäss dem revidierten Schweizer Datenschutzgesetz (revDSG) sowie, soweit anwendbar, der EU-Datenschutz-Grundverordnung (DSGVO)." },
      { h: "1. Verantwortliche Stelle", p: "MYSYMP AG, Studenstrasse 14B, CH-6207 Nottwil, Schweiz, ist verantwortlich für die Bearbeitung der über diese Website (mira-mirror.ai) erhobenen Personendaten.\n\nE-Mail: info@mysymp.ch\nTelefon: +41 79 471 06 25" },
      { h: "2. Bearbeitete Daten", p: "Wir bearbeiten Daten, die Sie uns über das B2B-Kontaktformular oder die Newsletter-Anmeldung aktiv übermitteln (z. B. Name, Boutique-Name, E-Mail-Adresse, Nachricht), sowie technisch notwendige Nutzungsdaten (z. B. IP-Adresse, Browsertyp), die beim Besuch der Website anfallen." },
      { h: "3. Zweck und Rechtsgrundlage", p: "Die Bearbeitung erfolgt zur Beantwortung von Anfragen, zur Organisation von Partner-Demos sowie zum Versand des Newsletters bzw. der Launch-Benachrichtigung (nur mit Ihrer Einwilligung, Art. 6 Abs. 1 lit. a DSGVO). Die Bearbeitung von Anfragen stützt sich auf die Anbahnung bzw. Erfüllung eines Vertrags (Art. 6 Abs. 1 lit. b DSGVO) sowie unser berechtigtes Interesse an der Kommunikation mit Interessenten (Art. 6 Abs. 1 lit. f DSGVO)." },
      { h: "4. Weitergabe an Dritte", p: "Eine Weitergabe erfolgt nur an Auftragsbearbeiter (z. B. Hosting- und E-Mail-Versanddienstleister) im erforderlichen Umfang und unter Wahrung angemessener Schutzmassnahmen. Es findet kein Verkauf Ihrer Daten statt." },
      { h: "5. Fotos in der App", p: "Fotos, die Sie in der Mira Mirror App analysieren, werden ausschliesslich für Ihre persönliche Analyse verwendet, verschlüsselt übertragen und nicht für Werbe- oder Trainingszwecke weitergegeben." },
      { h: "6. Speicherdauer", p: "Personendaten werden nur so lange gespeichert, wie es für die genannten Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Newsletter-Daten werden bis zu Ihrer Abmeldung gespeichert." },
      { h: "7. Ihre Rechte", p: "Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Bearbeitung Ihrer Daten, das Recht auf Datenübertragbarkeit sowie das Recht, erteilte Einwilligungen jederzeit zu widerrufen. Wenden Sie sich hierfür an info@mysymp.ch. Zudem steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu (in der Schweiz: EDÖB; in der EU: die Datenschutzbehörde Ihres Mitgliedstaats)." },
    ],
  },
};

export default function Legal({ page }) {
  const { t } = useLang();
  const title = page === "impressum" ? t.legal.impressumTitle : t.legal.datenschutzTitle;
  const content = CONTENT[page];

  return (
    <main style={{ background: "var(--surface)", color: "var(--on-surface)" }} className="min-h-screen">
      <Navbar />
      <div className="mx-auto max-w-3xl px-5 sm:px-8 pt-36 pb-24" data-testid={`legal-page-${page}`}>
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-sm font-medium transition-colors duration-300 hover:text-[var(--camel)]"
          style={{ color: "var(--muted-warm)" }}
        >
          <ArrowLeft size={15} /> {t.legal.back}
        </Link>
        <h1 className="mt-8 font-serif-display text-4xl sm:text-5xl font-semibold" data-testid="legal-title">
          {title}
        </h1>
        <div className="mt-12 space-y-10">
          {content.sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-serif-display text-2xl font-semibold">{s.h}</h2>
              <p className="mt-3 whitespace-pre-line text-sm sm:text-base leading-relaxed" style={{ color: "var(--muted-warm)" }}>
                {s.p}
              </p>
            </section>
          ))}
        </div>
      </div>
      <Footer />
    </main>
  );
}
